import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
// import Datetime from 'react-datetime'
import moment from 'moment'

// Modals
import NewPunchModal from '../../shared/modals/NewPunchModal'
import { triggerPopup } from '../../actions/backdrop'

// import components
import Header from './../../shared/components/Header'
import Confirm from './../../shared/components/Confirm'
import Portal from './../../shared/components/Portal'

// Elements
import TabBar from '../../shared/elements/tabBar'
import TabItem from '../../shared/elements/tabItem'
import Button from '../../shared/elements/button'
import DateTime from '../../shared/elements/datetime'
import DropDown from '../../shared/elements/dropDown'
import Panel from '../../shared/elements/panel'
import Col from '../../shared/elements/col'
import Row from '../../shared/elements/row'
import TableContainer from '../../shared/elements/tableContainer'
import TableRow from '../../shared/elements/tableRow'
import Text from '../../shared/elements/text'
import Check from '../../shared/elements/check'
import AddButton from '../../shared/elements/addButton'
import RemoveButton from '../../shared/elements/removeButton'
// import Inline from '../../shared/elements/inline'

// import actions
import { getEmployeePunchTimes, editEmployeePunchTimes } from './../../actions/punchclock'

// import styles
import './punchedit.scss'

// Utils
import { renderFullDate } from '../../utils/time'
import { translation } from '../../utils/helpers'
import { hasSubscriptionPermission } from '../../utils/auth'
// import { Icons } from '../../shared/elements/icons'

class PunchEdit extends Component {
  constructor (props) {
    super(props)
    this.state = {
      Times: [
        {
          PunchClockStatId: 0,
          PunchIn: null,
          PunchOut: null,
          AwayDate: null,
          Date: null,
          Day: null,
          ModifiedByAdmin: false,
          CheckVacation: false,
          CheckSick: false,
          CheckSickChild: false,
          CheckPaidAbsence: false,
          CheckUnPaidAbsence: false
        }
      ],
      From: null,
      To: null,
      UserId: null,
      ShowNewPunchModal: false,
      ChangeAllPopup: {
        Show: false,
        Confirmed: false
      }
    }
    this.renderHeaderTitle = this.renderHeaderTitle.bind(this)
    this.renderInputArea = this.renderInputArea.bind(this)
    this.renderReportArea = this.renderReportArea.bind(this)
    this.renderReportHeader = this.renderReportHeader.bind(this)
    this.getPunchTimes = this.getPunchTimes.bind(this)
    this.getReportFromState = this.getPunchTimesFromState.bind(this)
    this.editPunchTimes = this.editPunchTimes.bind(this)
    this.setHourMin = this.setHourMin.bind(this)
    this.toggleNewPunchModal = this.toggleNewPunchModal.bind(this)
    this.setPunchTimes = this.setPunchTimes.bind(this)
    this.showChangeAll = this.showChangeAll.bind(this)
    this.closeChangeAll = this.closeChangeAll.bind(this)
    this.setUserIdFromProps = this.setUserIdFromProps.bind(this)
  }

  componentDidMount () {
    if (this.props.location.query !== undefined) {
      let query = this.props.location.query
      let userId = query.UserId
      let fromDate = query.From
      let toDate = query.To

      if (userId === undefined || userId === null || userId === 'undefined') userId = 0
      if (fromDate === undefined || fromDate === 'undefined') fromDate = null
      if (toDate === undefined || toDate === 'undefined') toDate = null

      // console.log('did mount: from', fromDate, 'to', toDate)
      // if (this.props.employees !== undefined && this.props.employees !== null && this.props.employees.length > 0) {
      //   userId = this.props.employees[0].UserId
      // }

      if (userId !== 0) {
        this.setState({
          UserId: userId
        }, () => {
          this.getPunchTimesFromState()
        })
      } else {
        this.setUserIdFromProps(this.props)
      }
      this.setState({
        From: fromDate !== null ? moment(fromDate) : null,
        To: toDate !== null ? moment(toDate) : null
      })
    }
  }

  componentWillReceiveProps (nextProps) {
    if (this.state.UserId === undefined || this.state.UserId === 0 || this.state.UserId === null) {
      this.setUserIdFromProps(nextProps)
    }
  }

  setUserIdFromProps (props) {
    console.log('props.employees', props.employees)
    if (props.employees !== undefined && props.employees !== null && props.employees.length > 0) {
      let userId = props.employees[0].UserId
      console.log('got props. UserId = ', userId)
      this.setState({
        UserId: userId
      }, () => {
        this.getPunchTimesFromState()
      })
    }
  }

  getPunchTimes (userId, fromDateTime, toDateTime) {
    if (typeof userId === 'undefined') {
      userId = this.refs.employeeSelect.value
    }

    this.props.getEmployeePunchTimes(userId, fromDateTime, toDateTime).then((res) => {
      this.setPunchTimes(res.data)
    })
  }

  setPunchTimes (data) {
    // console.log('times', data)
    let times = []
    for (let i = 0; i < data.PunchTimeStats.length; i++) {
      let item = data.PunchTimeStats[i]
      let entry = {
        PunchClockStatId: item.PunchClockStatId,
        PunchIn: item.PunchIn,
        PunchOut: item.PunchOut,
        AwayDate: item.Away,
        Date: item.Date,
        Day: item.Day,
        ModifiedByAdmin: item.ModifiedByAdmin,
        CheckVacation: item.AwayType === 0,
        CheckSick: item.AwayType === 1,
        CheckSickChild: item.AwayType === 2,
        CheckPaidAbsence: item.AwayType === 3,
        CheckUnPaidAbsence: item.AwayType === 4
      }
      times.push(entry)
    }

    this.setState({
      Times: times
    })
  }

  saveNewEntry (entry) {
    // console.log('New entry', entry)
    entry.PunchClockStatId = 0
    let times = [...this.state.Times]
    times.push(entry)
    // console.log('New entry', entry, 'all entries', times)
    if (this.state.ShowNewPunchModal === true) {
      this.toggleNewPunchModal()
    }
    this.setState({
      Times: times
      // ShowNewPunchModal: false
    }, () => {
      this.editPunchTimes()
      // this.props.triggerPopup(!this.state.ShowNewPunchModal)
    })
  }

  editPunchTimes () {
    const formatDate = (moment) => {
      return moment.year() + '-' + (moment.month() + 1) + '-' + moment.date()
    }

    let editedTimes = []
    for (let i = 0; i < this.state.Times.length; i++) {
      let entry = this.state.Times[i]
      let awayType = null
      let awayDate = null
      if (entry.CheckVacation) awayType = 0
      if (entry.CheckSick) awayType = 1
      if (entry.CheckSickChild) awayType = 2
      if (entry.CheckPaidAbsence) awayType = 3
      if (entry.CheckUnPaidAbsence) awayType = 4

      if (awayType !== null) {
        awayDate = (entry.AwayDate !== null && entry.AwayDate !== undefined) ? entry.AwayDate : entry.Date
        if (awayDate === null) {
          continue // Invalid entry
        }
      }

      let item = {
        PunchClockStatId: entry.PunchClockStatId,
        PunchIn: entry.PunchIn,
        PunchOut: entry.PunchOut,
        ModifiedByAdmin: entry.ModifiedByAdmin,
        AwayType: awayType,
        Away: awayDate
      }
      editedTimes.push(item)
    }
    let data = {
      UserId: this.state.UserId,
      PunchTimeStats: editedTimes,
      From: formatDate(this.state.From),
      To: formatDate(this.state.To)
    }
    // console.log('Data', data)
    this.props.editEmployeePunchTimes(data).then((res) => {
      this.setPunchTimes(res.data)
      if (res.data.Error === null) {
        // window.toastr.success(translation('2208'), translation('13424'))
      } else {
        window.toastr.error(translation('2209'), translation(res.data.Error.DictionaryKey))
      }
    }, () => {
      // console.log(err.response.data)
      window.toastr.error(translation('2209'), translation('216'))
    })
  }

  getPunchTimesFromState () {
    let userId = this.state.UserId
    if (userId === 0) return
    if (this.state.From === null) return null
    if (this.state.To === null) return null
    const formatDate = (moment) => {
      return moment.year() + '-' + (moment.month() + 1) + '-' + moment.date()
    }
    this.getPunchTimes(userId, formatDate(this.state.From), formatDate(this.state.To))
  }

  toggleNewPunchModal () {
    // console.log('Toggle new punch modal')
    this.props.triggerPopup(!this.state.ShowNewPunchModal)
    this.setState({
      ShowNewPunchModal: !this.state.ShowNewPunchModal
    })
  }

  renderHeaderTitle () {
    return translation('2206')
  }

  renderReportHeader (title) {
    return (
      <div className='report_header'>{translation(title)}</div>
    )
  }

  renderInputArea () {
    const onDateChange = (name, e) => {
      this.setState({[name]: e})
    }

    const onEmployeeChange = (e) => {
      let userId = e.target.value
      if (this.state.UserId !== userId) {
        this.setState({UserId: userId})
      }
    }

    const onShowReportClick = (e) => {
      e.preventDefault()
      this.getPunchTimesFromState()
    }

    let canClickButtons = false
    if (this.state.From !== '' && this.state.To !== '' && this.state.From !== null && this.state.To !== null && this.state.UserId > 0) {
      canClickButtons = true
    }

    return (
      <Panel title=''>
        <DropDown labelText={translation('449')} name='employee' onChange={onEmployeeChange} value={this.state.UserId}>
          <option key={0} value={null}>{translation(1440)}</option>
          {this.props.employees.map((emp) => {
            if (emp.Active) {
              return (<option key={emp.UserId} value={emp.UserId}>{emp.Name}</option>)
            }
          })}
        </DropDown>
        <DateTime
          labelText={translation('434')}
          inputProps={{
            name: 'from',
            readOnly: true,
            placeholder: translation('1728')
          }}
          dateFormat='DD-MM-YYYY'
          timeFormat={false}
          closeOnSelect
          value={this.state.From}
          onChange={onDateChange.bind(this, 'From')} />
        <DateTime
          labelText={translation('187')}
          inputProps={{
            name: 'to',
            readOnly: true,
            placeholder: translation('1728')
          }}
          dateFormat='DD-MM-YYYY'
          timeFormat={false}
          closeOnSelect
          value={this.state.To}
          onChange={onDateChange.bind(this, 'To')} />
        <Button spacing={0} disabled={!canClickButtons} onClick={onShowReportClick} labelText={translation('380')} />
      </Panel>
    )
  }

  setHourMin (dateTime, hhmm) {
    // Format is 2017-04-02T10:41:16
    if (hhmm !== null && hhmm.length === 4) {
      if (hhmm.indexOf(':') === -1) {
        hhmm = hhmm.substring(0, 2) + ':' + hhmm.substring(2, 4)
      } else if (hhmm.indexOf(':') === 1) {
        hhmm = '0' + hhmm
      }
    }
    console.log('hhmm', hhmm)
    let result = dateTime.substring(0, 11) + hhmm
    return result
  }

  renderReportArea () {
    if (this.state.Times === undefined || this.state.Times === null) return null
    let entries = this.state.Times
    const renderEntries = () => {
      const BLANK = <span>&nbsp;</span>
      let prevDate = null
      const renderEntry = (entry, key) => {
        // console.log(entry)
        if (entry.PunchIn === null && entry.PunchOut === null && (entry.Date === null || entry.AwayDate === null)) return null
        const renderAwayCheck = (entry, type, key) => {
          let name = ''
          let label = ''
          switch (type) {
            case 0:
              name = 'CheckVacation'
              label = '500'
              break
            case 1:
              name = 'CheckSick'
              label = '508'
              break
            case 2:
              name = 'CheckSickChild'
              label = '502'
              break
            case 3:
              name = 'CheckPaidAbsence'
              label = '1436'
              break
            case 4:
              name = 'CheckUnPaidAbsence'
              label = '1435'
              break
          }
          let value = entry[name]

          const onChangeAwayType = (e) => {
            entry.CheckVacation = false
            entry.CheckSick = false
            entry.CheckSickChild = false
            entry.CheckPaidAbsence = false
            entry.CheckUnPaidAbsence = false
            entry[name] = e.target.checked

            if (entry.CheckVacation || entry.CheckSick || entry.CheckSickChild || entry.CheckPaidAbsence || entry.CheckUnPaidAbsence) {
              if (entry.AwayDate === null) entry.AwayDate = entry.Date
            } else {
              // console.log('setting punch in to', entry.Date, entry)
              // if (entry.PunchIn === null) entry.PunchIn = entry.Date
            }
            if (entry.PunchClockStatId < 0) {
              entry.PunchClockStatId = 0 // Instruct api to create this entry
            }
            let times = [...this.state.Times]
            times[key] = entry
            this.setState({
              Times: times
            }, () => {
              this.editPunchTimes()
            })
          }

          return (
            <Check labelText={translation(label)} id={name + '_' + key} name={name} value='0' onChange={onChangeAwayType.bind(this)} checked={value === true} />
          )
        }

        const onChangeTime = (e) => {
          e.persist()
          entry = this.state.Times[key]
          let value = e.target.value
          // if (value === '') value = null
          if (e.target.name === 'punchIn') {
            // if (entry.CheckVacation || entry.CheckSick || entry.CheckSickChild || entry.CheckPaidAbsence || entry.CheckUnPaidAbsence) {
            //   entry.AwayDate = this.setHourMin(entry.AwayDate, value)
            // } else {
            if (entry.PunchIn === null) entry.PunchIn = entry.Date
            entry.PunchIn = this.setHourMin(entry.PunchIn, value)
            // }
          } else if (e.target.name === 'punchOut') {
            if (entry.PunchOut === null) entry.PunchOut = entry.Date
            entry.PunchOut = this.setHourMin(entry.PunchOut, value)
          }

          if (entry.PunchClockStatId < 0) {
            entry.PunchClockStatId = 0 // Instruct api to create this entry
          }

          // let times = [...this.state.Times]
          let times = this.state.Times
          times[key] = entry
          this.setState({
            Times: times
          }, () => {
            e.target.focus()
          })
        }

        const onDelete = (e) => {
          entry = this.state.Times[key]
          entry.PunchIn = null
          entry.PunchOut = null
          entry.CheckVacation = false
          entry.CheckSick = false
          entry.CheckSickChild = false
          entry.CheckPaidAbsence = false
          entry.CheckUnPaidAbsence = false
          entry.AwayDate = null
          let times = [...this.state.Times]
          times[key] = entry
          this.setState({
            Times: times
          }, () => {
            this.editPunchTimes()
          })
        }

        let date = entry.Date
        if (date === undefined || date === null) return null
        let punchIn = entry.PunchIn !== null ? entry.PunchIn.substring(11, 16) : ''
        let punchOut = entry.PunchOut !== null ? entry.PunchOut.substring(11, 16) : ''
        let isAbsence = entry.AwayDate !== null && (entry.CheckVacation || entry.CheckSick || entry.CheckSickChild || entry.CheckPaidAbsence || entry.CheckUnPaidAbsence)
        console.log('Entry', entry)
        let dayClass = ''
        let day = ''
        switch (entry.Day) {
          case 0: // sunday
            day = translation('175').substring(0, 3)
            dayClass = 'weekend'
            break
          case 1: // monday
            day = translation('169').substring(0, 3)
            break
          case 2: // ..
            day = translation('170').substring(0, 3)
            break
          case 3: // ..
            day = translation('171').substring(0, 3)
            break
          case 4: // ..
            day = translation('172').substring(0, 3)
            break
          case 5: // friday
            day = translation('173').substring(0, 3)
            break
          case 6: // saturday
            day = translation('174').substring(0, 3)
            dayClass = 'weekend'
            break

        }

        day = day.substring(0, 3)

        let dateShown = renderFullDate(date, false)
        let newDay = true
        // If current entry date is same as previous entry date, don't write out date again.
        if (prevDate !== null && prevDate !== undefined) {
          if (prevDate.substring(0, 10) === date.substring(0, 10)) {
            dateShown = BLANK
            day = BLANK
            newDay = false
          }
        }
        prevDate = date
        if (!newDay) {
          return (
            <TableRow key={'entry_' + key} cols={[1, 1, 1, 1, 1, 1, 1, 1, 'min-content']}>
              <div className={'date'}>
                <span className={dayClass}>{day}</span>
                <span className={dayClass}>{dateShown}</span>
              </div>
              <Text size='m' name='punchIn' maxLength='5' value={punchIn || ''} onChange={onChangeTime} onBlur={this.editPunchTimes} disabled={isAbsence} />
              <Text size='m' name='punchOut' maxLength='5' value={punchOut || ''} onChange={onChangeTime} onBlur={this.editPunchTimes} disabled={isAbsence} />
              <div>{BLANK}</div>
              <div>{BLANK}</div>
              <div>{BLANK}</div>
              <div>{BLANK}</div>
              <div>{BLANK}</div>
              <RemoveButton round size='s' onClick={onDelete} />
            </TableRow>
          )
        } else {
          return (
            <TableRow key={'entry_' + key} cols={[1, 1, 1, 1, 1, 1, 1, 1, 'min-content']}>
              <div className={'date'}>
                <span className={dayClass}>{day}</span>
                <span className={dayClass}>{dateShown}</span>
              </div>
              <Text size='m' name='punchIn' maxLength='5' value={punchIn === null ? '' : punchIn} onChange={onChangeTime} onBlur={this.editPunchTimes} disabled={isAbsence} />
              <Text size='m' name='punchOut' maxLength='5' value={punchOut === null ? '' : punchOut} onChange={onChangeTime} onBlur={this.editPunchTimes} disabled={isAbsence} />
              <div>{renderAwayCheck(entry, 0, key)}</div>
              <div>{renderAwayCheck(entry, 1, key)}</div>
              <div>{renderAwayCheck(entry, 2, key)}</div>
              <div>{renderAwayCheck(entry, 3, key)}</div>
              <div>{renderAwayCheck(entry, 4, key)}</div>
              <RemoveButton round size='s' onClick={onDelete} />
            </TableRow>
          )
        }
      }

      const isAllChecked = (type) => {
        for (let i = 0; i < this.state.Times.length; i++) {
          let entry = this.state.Times[i]
          switch (type) {
            case 0:
              if (!entry.CheckVacation) return false
              break
            case 1:
              if (!entry.CheckSick) return false
              break
            case 2:
              if (!entry.CheckSickChild) return false
              break
            case 3:
              if (!entry.CheckPaidAbsence) return false
              break
            case 4:
              if (!entry.CheckUnPaidAbsence) return false
              break
          }
        }
        return true
      }

      const onChangeAll = (e) => {
        this.showChangeAll(e.target.name)
      }

      return (
        <Row>
          <TableContainer>
            <TableRow header cols={[1, 1, 1, 1, 1, 1, 1, 1, 'min-content']}>
              <div>{translation('388')}</div>
              <div>{translation('443')}</div>
              <div>{translation('1899')}</div>
              <Check spacing={0} labelText={translation('381')} id='all_vacation' name='all_vacation' value='0' onChange={onChangeAll} checked={isAllChecked(0)} />
              <Check spacing={0} labelText={translation('381')} id='all_sick' name='all_sick' value='0' onChange={onChangeAll} checked={isAllChecked(1)} />
              <Check spacing={0} labelText={translation('381')} id='all_sickchild' name='all_sickchild' value='0' onChange={onChangeAll} checked={isAllChecked(2)} />
              <Check spacing={0} labelText={translation('381')} id='all_paidabsence' name='all_paidabsence' value='0' onChange={onChangeAll} checked={isAllChecked(3)} />
              <Check spacing={0} labelText={translation('381')} id='all_unpaidabsence' name='all_unpaidabsence' value='0' onChange={onChangeAll} checked={isAllChecked(4)} />
              <AddButton size='s' onClick={this.toggleNewPunchModal} />
            </TableRow>
            {entries.map(renderEntry)}
          </TableContainer>
        </Row>
      )
    }

    return (
      this.state.Times.length > 0 && renderEntries()
    )
  }

  showChangeAll (arg) {
    let popup = { ...this.state.ChangeAllPopup }
    popup.Confirmed = false
    popup.Show = true
    popup.Arg = arg

    this.setState({
      ChangeAllPopup: popup
    })
  }

  closeChangeAll (confirm = false) {
    let popup = { ...this.state.ChangeAllPopup }
    let arg = popup.Arg
    popup.Confirmed = confirm
    popup.Show = false
    popup.Arg = null
    this.setState({
      ChangeAllPopup: popup
    }, () => {
      if (confirm && arg !== null && arg !== undefined) {
        let times = [...this.state.Times]
        for (let i = 0; i < times.length; i++) {
          times[i].CheckVacation = true
          times[i].CheckSick = false
          times[i].CheckSickChild = false
          times[i].CheckPaidAbsence = false
          times[i].CheckUnPaidAbsence = false
          switch (arg) {
            case 'all_vacation':
              times[i].CheckVacation = true
              break
            case 'all_sick':
              times[i].CheckSick = true
              break
            case 'all_sickchild':
              times[i].CheckSickChild = true
              break
            case 'all_paidabsence':
              times[i].CheckPaidAbsence = true
              break
            case 'all_unpaidabsence':
              times[i].CheckUnPaidAbsence = true
              break
          }
          if (times[i].PunchClockStatId === -1) {
            times[i].PunchClockStatId = 0
          }
          // times[i].PunchIn = null
          // times[i].PunchOut = null
          times[i].AwayDate = times[i].Date
        }
        this.setState({
          Times: times
        }, () => {
          this.editPunchTimes()
          // console.log('State after set all', this.state)
        })
      }
    })
  }

  render () {
    if (!hasSubscriptionPermission(this.props.auth, 20)) return null
    const formatDate = (moment) => {
      let year = moment.year()
      let month = moment.month() + 1
      let day = moment.date()

      month = month < 10 ? '0' + month.toString() : month.toString()
      day = day < 10 ? '0' + day.toString() : day.toString()
      return year + '-' + month + '-' + day
    }
    let fromDate = this.state.From !== null && this.state.From !== '' ? formatDate(this.state.From) : null
    let toDate = this.state.To !== null && this.state.To !== '' ? formatDate(this.state.To) : null

    let editLinkParams = ''
    if (this.state.UserId !== 0) {
      editLinkParams += (editLinkParams === '' ? '?' : '&')
      editLinkParams += 'UserId=' + this.state.UserId
    }
    if (this.state.From !== null && this.state.From !== '') {
      editLinkParams += (editLinkParams === '' ? '?' : '&')
      editLinkParams += 'From=' + fromDate
    }

    if (this.state.To !== null) {
      editLinkParams += (editLinkParams === '' ? '?' : '&')
      editLinkParams += 'To=' + toDate
    }

    return (
      <div className='punchedit__screen'>
        <Header router={this.props.router} >
          <TabBar>
            <TabItem><Link to={'/punchreport' + editLinkParams} >{translation('2159')}</Link></TabItem>
            <TabItem><Link to={'/punchedit' + editLinkParams} className='active'>{translation('2206')}</Link></TabItem>
            <TabItem><Link to={'/absencereport'}>{translation('1128')}</Link></TabItem>
          </TabBar>
        </Header>
        <Row>
          <Col>{this.renderInputArea()}</Col>
        </Row>
        {this.renderReportArea()}
        <NewPunchModal
          saveNewEntry={this.saveNewEntry.bind(this)}
          show={this.state.ShowNewPunchModal}
          onClose={this.toggleNewPunchModal} />
        {this.state.ChangeAllPopup.Show && (
          <Portal className='confirm_popup' onPortalClose={this.closeChangeAll.bind(this, false)}>
            <Confirm confirm={this.closeChangeAll.bind(this, true)} notConfirm={this.closeChangeAll.bind(this, false)} renderText={() => { return (<p>{translation('2207')}</p>) }} />
          </Portal>
        )}
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    employees: state.common.employees
  }
}

export default connect(mapStateToProps, {
  renderFullDate,
  getEmployeePunchTimes,
  editEmployeePunchTimes,
  triggerPopup
})(PunchEdit)



// WEBPACK FOOTER //
// ./src/app/pages/PunchEdit/index.js